module.exports = __webpack_public_path__ + "static/media/check02.742f7ea2.gif";